import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/app/(auth)/sign-up/[[...sign-up]]/page.tsx");
